export default __webpack_public_path__ + "locales/sr-Cyrl-RS/EmptyTrashDialog.json?hash=9e93d37fda75dd96180a4ad34864b791";